import { render, staticRenderFns } from "./TitleDetailV1.vue?vue&type=template&id=7508ee7e&scoped=true"
import script from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleDetailV1.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleDetailV1.vue?vue&type=style&index=0&id=7508ee7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7508ee7e",
  null
  
)

export default component.exports